import QuestionAnswer from 'models/common/form/questionAnswer/QuestionAnswer';

export default class CustomQuestionAnswer extends QuestionAnswer {}
